import React, { useMemo, useState } from 'react';
import './CourseStudentsModal.css';

export default function CourseStudentsModal({ data, onClose }) {
  const [searchTerm, setSearchTerm] = useState('');

  const students = data?.students || [];

  const filteredStudents = useMemo(() => {
    if (!searchTerm.trim()) return students;
    const q = searchTerm.toLowerCase();
    return students.filter(
      (s) =>
        s.name?.toLowerCase().includes(q) ||
        s.email?.toLowerCase().includes(q) ||
        s.phone?.includes(searchTerm)
    );
  }, [students, searchTerm]);

  const totalEnrolled = data?.totalEnrolled || students.length;

  return (
    <div className="CourseModal-overlay" onClick={onClose}>
      <div
        className="CourseModal-container"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="CourseModal-header">
          <div>
            <span className="CourseModal-subtitle">Enrolled Roster</span>
            <h3>{data?.courseTitle || 'Course Roster'}</h3>
          </div>
          <button
            className="CourseModal-close-btn"
            onClick={onClose}
            aria-label="Close modal"
          >
            ✕
          </button>
        </div>

        <div className="CourseModal-stats-strip">
          <div className="CourseModal-stat-box">
            <span>Total Enrolled</span>
            <strong>{totalEnrolled}</strong>
          </div>
          <input
            type="text"
            placeholder="🔍 Search by name, email or phone..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="CourseModal-search-input"
          />
        </div>

        <div className="CourseModal-body">
          {filteredStudents.length === 0 ? (
            <p className="CourseModal-empty">
              {students.length === 0
                ? 'No students found for this course.'
                : 'No students match your search.'}
            </p>
          ) : (
            <table className="CourseModal-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Student Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Enrolled On</th>
                </tr>
              </thead>
              <tbody>
                {filteredStudents.map((student, idx) => (
                  <tr key={student._id || idx}>
                    <td>{idx + 1}</td>
                    <td>
                      <strong>{student.name || 'N/A'}</strong>
                    </td>
                    <td>{student.email || 'N/A'}</td>
                    <td>{student.phone || 'N/A'}</td>
                    <td>
                      {student.createdAt
                        ? new Date(student.createdAt).toLocaleDateString()
                        : 'N/A'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="CourseModal-footer">
          <button className="CourseModal-btn-close" onClick={onClose}>
            Close Window
          </button>
        </div>
      </div>
    </div>
  );
}